import React from 'react'
import { Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { FindInPageOutlined, AnnouncementOutlined } from '@mui/icons-material'
import { useIntl } from 'react-intl'

import { CustomActionButtons, useModalContext } from '../../../../ui'
import { DocumentsView } from '../documents-view'

const EI_BUTTONS = (navigate, primaryCompany, open, params) => ({
  DOCUMENTS_VIEW: {
    id: 'documents_view',
    icon: <FindInPageOutlined />,
    onClick: () => {
      open({
        Component: DocumentsView,
        data: { company: primaryCompany },
        type: 'responsive',
        closable: true,
      })
    },
  },
  APPLICATIONS: {
    id: 'applications',
    icon: <AnnouncementOutlined />,
    onClick: () => {
      navigate('/applications', { replace: true, search: `?eeii_id=${params}` })
    },
  },
})

const userButtons = ['DOCUMENTS_VIEW', 'APPLICATIONS']

export const EIActionButtons = ({ primaryCompany }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()

  const params = location.search.substring(4)

  const buttons = EI_BUTTONS(navigate, primaryCompany, open, params)

  return (
    <Box pb={1}>
      <CustomActionButtons
        iconButtons={userButtons.map((index) => {
          return {
            ...buttons[index],
            label: formatMessage({ id: `pages.ei.customActionButtons.${buttons[index].id}.title` }),
          }
        })}
      />
    </Box>
  )
}

export default EIActionButtons
